import { useJobillaOrgId } from '@/hooks'
import { CheckIcon, DocumentArrowUpIcon } from '@heroicons/react/20/solid'
import { useOrganisationRelationShow } from '@jobilla/nexus-sdk'
import { useTranslation } from 'react-i18next'

export function CandidateProfileCard() {
	const { t } = useTranslation('editor')
	const organisationId = useJobillaOrgId()
	const { data: organisation } = useOrganisationRelationShow(organisationId, { enabled: !!organisationId })
	const collectsCv = organisation?.candidateProfileCvCollectionEnabled === true
	const candidateProfileEnabled = organisation?.candidateProfileEnabled === true

	const askedFor = [
		{
			title: t('candidateProfile.workHistory'),
			description: t('candidateProfile.workHistoryDescription'),
		},
		{
			title: t('candidateProfile.education'),
			description: t('candidateProfile.educationDescription'),
		},
		{
			title: t('candidateProfile.licenses'),
			description: t('candidateProfile.licensesDescription'),
		},
	]

	return (
		<div className="mt-6 ring ring-grey-200 bg-white rounded-sm shadow-lg p-6" style={{ width: '500px' }}>
			<h3 className="text-base font-semibold text-grey-900">
				{t('candidateProfile.title')}
			</h3>

			<p className="mt-4 text-sm text-grey-600">
				{organisation?.candidateProfileEnabled !== false
					? t('candidateProfile.description')
					: collectsCv
					? t('candidateProfile.descriptionCvOnly')
					: t('candidateProfile.descriptionApplicationOnly')}
			</p>

			{collectsCv
				? (
					<div className="mt-4 flex items-center gap-3 rounded-sm border border-purple-200 bg-purple-50 px-3.5 py-3 text-purple-900">
						<DocumentArrowUpIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
						<p className="text-sm font-semibold">{t('candidateProfile.cvUpload')}</p>
					</div>
				)
				: null}

			{candidateProfileEnabled
				? (
					<div className="mt-5 pt-4 border-t border-grey-100">
						<p className="text-xs font-semibold uppercase tracking-wide text-grey-500">
							{t('candidateProfile.askedFor')}
						</p>
						<ul className="mt-3 flex flex-col gap-3">
							{askedFor.map((askedForItem) => (
								<li key={askedForItem.title} className="flex items-start gap-3">
									<CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-purple-600" aria-hidden="true" />
									<div>
										<p className="text-sm font-medium text-grey-900">{askedForItem.title}</p>
										<p className="text-sm text-grey-500">{askedForItem.description}</p>
									</div>
								</li>
							))}
						</ul>
						<p className="mt-4 text-sm text-grey-500">
							{t('candidateProfile.skipHint')}
						</p>
					</div>
				)
				: null}
		</div>
	)
}
